import { Component, OnInit } from '@angular/core';
import { AlertService } from '../../servicios/alert.service';
import { loading_show, loading_hide } from '../../app.helpers';
import { Result } from '../../servicios/servers.service';
import { TipoServicioService } from '../../servicios/tiposervicio.service';
declare var jQuery: any;

@Component({
    selector: 'tipoServicio',
    templateUrl: 'tipoServicio.template.html'
})

export class TipoServicioComponent implements OnInit {

    constructor(
        private alertService: AlertService,
        private tipoServicioService: TipoServicioService
    ) {

    }

    ngOnInit() {
        
        this.getTipoServicios();
    }
    public filter = "";
    public tipoServicio:any = {};
    public tipoServicios = [];
    public update = false;
    
    files: FileList;
    
    getTipoServicios(){
        loading_show();
        this.tipoServicioService.getAll((data: Result) => {
            loading_hide();
            
            if (data.isOk) {
                this.tipoServicios = data.Content;
            }

        });
    }

    getFiles(event: any) {
        this.files = event.target.files;
        for (var i = 0, f; f = this.files[i]; i++) {
            if (!f.type.match('image.*')) {
                continue;
            }
            var reader = new FileReader();
            reader.onload = (function (theFile) {
                return function (e) {
                    document.getElementById("image").innerHTML = ['<img class="animated bounceIn" style="width:60%; margin-left:20%" src="', e.target.result, '" />'].join('');
                };
            })(f);
            reader.readAsDataURL(f);
        }
    }

    saveTipoServicio() {
        //let formData: FormData = new FormData();

        /*if (!this.files) {
            this.alertService.warning('por favor cargar logo del empresa');
            return;
        }*/

        if (!this.tipoServicio['estado']) {
            this.tipoServicio['estado'] = 'ACTIVO';
        }

        //formData.append('imagen', this.files[0]);


        var object = {
            'nombre': this.tipoServicio['nombre'],
            'estado': this.tipoServicio['estado'],
        }

        //formData.append('empresa', JSON.stringify(object));

        loading_show();
        this.tipoServicioService.save(object, (data: Result) => {
            loading_hide();

            if (data.isOk) {
                this.getTipoServicios();
                this.tipoServicio = {}
                this.alertService.success(data.Mensaje);
            }
        });

    }

    showTipoServicio(tipoServicio: any) {
        this.tipoServicio = tipoServicio;
        this.update = true;
        jQuery("#t1").addClass("active");
        jQuery("#t2").removeClass("active");
        jQuery("#tab-1").addClass("active");
        jQuery("#tab-2").removeClass("active");
    }


    cancel() {
        this.tipoServicio = this.tipoServicio[0];
        this.update = false;
        document.getElementById("image").innerHTML = '<div class="row">' +
            '<div class="col-lg-12" style="text-align: center;">' +
            '<i class="fa fa-image ico-bg"></i>' +
            '</div>' +
            '</div>';
    }

    updateTipoServicio() {
        /*let formData: FormData = new FormData();

        if (this.files) {
            formData.append('imagen', this.files[0]);
        }*/


        if (!this.tipoServicio['estado']) {
            this.tipoServicio['estado'] = 'ACTIVO';
        }


        var object = {
            'id': this.tipoServicio['id'],
            'nombre': this.tipoServicio['nombre'],
            'estado': this.tipoServicio['estado']
        }

        //formData.append('empresa', JSON.stringify(object));

        loading_show();
        this.tipoServicioService.update(object, (data: Result) => {
            loading_hide();
            console.log(data)
            if (data.isOk) {
                this.update = false;
                this.getTipoServicios();
                this.tipoServicio = {};
                this.alertService.success(data.Mensaje);

            }
        });
    }


    updateState(id: number, state: string) {
        
        loading_show();
        var object = {
            'id': id,
            'estado': state
        }

        this.tipoServicioService.updateState(object, (data: Result) => {
            loading_hide();
            if (data.isOk) {
                this.alertService.success("Estado actualizado");
                this.getTipoServicios();
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/views/tipoServicio/tipoServicio.component.ts